import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressInputFieldProps } from '../../types/customerAddressInputFieldProps'

type CustomerCityProps = CustomerAddressInputFieldProps

export const CustomerCity = ({ isDisabled = false }: CustomerCityProps): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()

  return (
    <FormItem
      itemColumnEnd={5}
      itemColumnStart={2}
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.address.city.label')}
      name="address.city"
      render={({ field }) => {
        return <Input {...field} disabled={isDisabled} size="sm" />
      }}
    />
  )
}
